import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { MyHealthIcon } from "../../../assets/icons";
import BlueButton from "../../../components/BlueButton";

const QuizOk = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.contentContainer}>
        <img src={MyHealthIcon} alt="my-health-icon" />
        <Typography variant="h2">Agradecemos pelo seu tempo!</Typography>
        <Typography>Você pode voltar e realizar o agendamento.</Typography>
      </Box>
      <BlueButton dataCy="go-appointment-button" href="/novo-agendamento">
        Seguir com agendamento
      </BlueButton>
    </Box>
  );
}

export default QuizOk;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      minHeight: '75vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        minHeight: '40vh',
      },
    },

    contentContainer: {
      marginBottom: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 150,
        filter: 'drop-shadow(0px 5px 10px #21212133)'
      },

      '& h2': {
        maxWidth: '65vw',
        marginTop: theme.spacing(4),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center'
      },

      '& p': {
        marginTop: theme.spacing(1),
        width: "90%",
        maxWidth: '90vw',
        textAlign: 'center',

        [theme.breakpoints.up('sm')]: {
          margin: theme.spacing(1, 0, 6),
          width: "71%",
        },
        [theme.breakpoints.up('lg')]: {
          width: "65%",
        },
      }
    },
  }))